import { styled } from '@mui/material/styles';
import { ListItemButton } from '@sunwisesoftware/sunwise-ui';

export default styled(ListItemButton)`
    background-color: ${({ theme }) => `${theme.palette.background.neutral}`};
    border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
    flex-grow: 0;
    padding: 16px;
    width: 100%;
`;
